$(function() {
    if($("#application_event_rejected_extract_enrichment").length){
        $(".radio").click(check_application_contact_resolves_rejected_extract);
        check_application_contact_resolves_rejected_extract()
    }
});

function check_application_contact_resolves_rejected_extract(){
    if ($("#application_event_rejected_extract_enrichment")[0].checked == true) {
        $("div.application_comment").hide()
    }else{
        $("div.application_comment").show()
    }
}
